function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) {
    callback(el);
    return;
  }
  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

// DROPDOWN PERSONALIZADO + SISTEMA DE PRECIOS - 4 TIPOS DE PRODUCTOS
document.addEventListener('DOMContentLoaded', function() {
  waitForElement('.product__info-wrapper', function() {
    // ELEMENTOS DROPDOWN
    const dropdownSelected = document.getElementById('dropdownSelected');
    const dropdownOptions = document.getElementById('dropdownOptions');
    const selectedText = document.querySelector('.selected-text');
    const dropdownOptionsList = document.querySelectorAll('.dropdown-option');
    
    // ELEMENTOS PRODUCTO
    const productData = getProductData();
    const hasDropdown = dropdownSelected && dropdownOptions && selectedText;
    
    // INICIALIZAR SISTEMA DE PRECIOS
    initializePriceSystem(productData);

    // DETECTAR Y CONFIGURAR SISTEMA SEGÚN TIPO DE PRODUCTO
    const systemType = detectAndConfigureVariants();
    
    if (systemType === 'variantes' || systemType === 'solo_precios') {
      if (hasDropdown) {
        initializeDropdown();
      }
    }
    
    // FUNCIÓN: DETECTAR SI HAY VARIANTES Y CONFIGURAR SISTEMA
    function detectAndConfigureVariants() {
      const hasDropdownEl = document.querySelector('.dropdown-option');
      const hasVariants = productData.product && productData.product.variants && productData.product.variants.length > 1;
      
      if (hasDropdownEl && hasVariants) {
        return 'variantes';
      } else if (hasVariants) {
        return 'solo_precios';
      } else {
        return 'simple';
      }
    }
    
    // FUNCIÓN: OBTENER DATOS DEL PRODUCTO
    function getProductData() {
      const productHandle = window.location.pathname.split('/').pop();
      let product = null;
      
      // Buscar JSON del producto en el DOM
      const selectors = [
        '[data-product-json]',
        'script[data-product-json]',
        'script[type="application/json"][data-product-json]'
      ];
      
      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element) {
          try {
            const jsonText = element.textContent || element.innerHTML;
            product = JSON.parse(jsonText);
            if (product && product.variants) {
              break;
            }
          } catch (e) {
            // Continuar con el siguiente selector
          }
        }
      }
      
      // Fallback a ShopifyAnalytics
      if (!product && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        product = window.ShopifyAnalytics.meta.product;
      }
      
      // Fallback a window.product
      if (!product && window.product) {
        product = window.product;
      }
      
      return {
        handle: productHandle,
        product: product,
        productType: getProductType(),
        isArnes: productHandle === 'arnes' || productHandle.includes('arnes')
      };
    }
    
    // FUNCIÓN: OBTENER TIPO DE PRODUCTO
    function getProductType() {
      const url = window.location.href;
      const productType = getMetafield('product_type');
      
      // 1. Arnés (prioritario - por URL o "ninguno")
      if (url.includes('arnes') || productType === 'ninguno') {
        return 'arnes';
      }
      
      // 2. Por metacampo específico  
      if (productType === 'dropdown_descuento') {
        return 'dropdown_descuento'; // Cama
      }
      
      if (productType === 'dropdown_simple') {
        return 'dropdown_simple'; // Correa/Guante
      }
      
      // 3. Por defecto → Multi-cantidad
      return 'multi_cantidad';
    }
    
    // FUNCIÓN: OBTENER METACAMPO
    function getMetafield(key) {
      const metafieldElement = document.querySelector(`[data-${key.replace('_', '-')}]`);
      if (metafieldElement) {
        return metafieldElement.dataset[key.replace(/_./g, x => x[1].toUpperCase())];
      }
      
      if (productData.product && productData.product.metafields) {
        const metafield = productData.product.metafields.find(m => 
          m.namespace === 'custom' && m.key === key
        );
        if (metafield) return metafield.value;
      }
      
      return null;
    }
    
    // FUNCIÓN: OBTENER PORCENTAJE DE DESCUENTO DEL METACAMPO
    function getDiscountPercentage() {
      const discountElement = document.querySelector('[data-discount-percentage]');
      if (discountElement) {
        const value = discountElement.dataset.discountPercentage;
        return parseInt(value) || 0;
      }
      
      // Si no hay metacampo, usar valores por defecto según tipo de producto
      const productType = getProductType();
      if (productType === 'arnes') return 20;
      if (productType === 'dropdown_descuento') return 15;
      
      return 0;
    }
    
    // FUNCIÓN: CALCULAR COMPARE AT PRICE BASADO EN DESCUENTO
    function calculateCompareAtPrice(price, discountPercentage) {
      if (!discountPercentage || discountPercentage === 0) {
        return price; // Sin descuento
      }
      // El tachado es el precio actual multiplicado por (1 + descuento)
      const multiplier = 1 + (discountPercentage / 100);
      return Math.round(price * multiplier);
    }
    
    // FUNCIÓN: OBTENER NÚMERO DE IMÁGENES DEL CARRUSEL
    function getCarouselImagesCount() {
      const carouselCountElement = document.querySelector('[data-carousel-images-count]');
      if (carouselCountElement) {
        const value = carouselCountElement.dataset.carouselImagesCount;
        return value;
      }
      
      return null;
    }
    
    // FUNCIÓN: CONFIGURAR VISIBILIDAD DEL CARRUSEL
    function setupCarouselVisibility(carouselCount) {
      if (!carouselCount || carouselCount.trim() === '') {
        return;
      }
      
      const hideFromImage = parseInt(carouselCount) + 1;
      
      if (isNaN(hideFromImage) || hideFromImage <= 1) {
        return;
      }
      
      const dynamicCSS = `
        @media (min-width: 750px) {
          .thumbnail-list__item:nth-child(n+${hideFromImage}) {
            display: none !important;
          }
          .thumbnail-list {
            justify-content: flex-start !important;
          }
        }
        @media (max-width: 749px) {
          .thumbnail-list__item {
            display: block !important;
          }
        }
      `;
      
      const styleElement = document.createElement('style');
      styleElement.id = 'dynamic-carousel-css';
      styleElement.textContent = dynamicCSS;
      document.head.appendChild(styleElement);
    }
    
    // FUNCIÓN: INICIALIZAR SISTEMA DE PRECIOS
    function initializePriceSystem(productData) {
      const productType = getProductType();

      switch(productType) {
        case 'arnes':
          renderArnesLayout();
          break;
          
        case 'dropdown_descuento':
          renderDropdownLayout();
          break;
          
        case 'dropdown_simple':
          renderSimpleLayout();
          break;
          
        case 'multi_cantidad':
          renderMultiQuantityLayout();
          break;
          
        default:
          renderSimpleLayout();
      }
      
      const carouselCount = getCarouselImagesCount();
      setupCarouselVisibility(carouselCount);
      
      updateDeliveryDate();
    }
    
    // FUNCIÓN: INICIALIZAR DROPDOWN
    function initializeDropdown() {
      // Abrir/cerrar dropdown
      dropdownSelected.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        dropdownSelected.classList.toggle('active');
        dropdownOptions.classList.toggle('show');
      });
      
      // Seleccionar opción
      dropdownOptionsList.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const selectedValue = this.getAttribute('data-value');
          const selectedImage = this.getAttribute('data-image');
          
          // Extraer solo la parte visible (antes del |) para mostrar
          let displayValue = selectedValue;
          if (selectedValue.includes('|')) {
            displayValue = selectedValue.split('|')[0].trim();
          }
          
          // Actualizar texto seleccionado con la parte visible
          selectedText.textContent = displayValue;
          
          // Cambiar imagen principal SOLO cuando se selecciona manualmente
          if (selectedImage && selectedImage.trim() !== '') {
            changeMainImage(selectedImage);
          }
          
          // ACTUALIZAR PRECIOS POR VARIANTE
          updatePricesByVariant(selectedValue);
          
          // Remover clase 'selected' de todas las opciones
          dropdownOptionsList.forEach(opt => opt.classList.remove('selected'));
          
          // Agregar clase 'selected' a la opción actual
          this.classList.add('selected');
          
          // Cerrar dropdown
          dropdownSelected.classList.remove('active');
          dropdownOptions.classList.remove('show');
        });
      });
      
      // Cerrar al hacer click fuera
      document.addEventListener('click', function(e) {
        if (!dropdownSelected.contains(e.target) && !dropdownOptions.contains(e.target)) {
          dropdownSelected.classList.remove('active');
          dropdownOptions.classList.remove('show');
        }
      });
    }
    
    // FUNCIÓN: CAMBIAR IMAGEN PRINCIPAL
    function changeMainImage(newImageUrl) {
      if (!newImageUrl || newImageUrl.trim() === '') return;
      
      findAndScrollToVariantImage(newImageUrl);
    }
    
    // FUNCIÓN: BUSCAR Y ACTIVAR IMAGEN DE VARIANTE
    function findAndScrollToVariantImage(variantImageUrl) {
      const allSlides = document.querySelectorAll('.product__media-item');
      let targetSlide = null;
      
      for (const slide of allSlides) {
        const img = slide.querySelector('img');
        if (img && imageUrlsMatch(img.src, variantImageUrl)) {
          targetSlide = slide;
          break;
        }
      }
      
      if (targetSlide) {
        const mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery) {
          mediaGallery.setActiveMedia(targetSlide.dataset.mediaId, false);
        }
      }
    }
    
    // FUNCIÓN: COMPARAR URLs DE IMÁGENES
    function imageUrlsMatch(url1, url2) {
      if (!url1 || !url2) return false;
      
      const getBaseName = (url) => {
        const fileName = url.split('/').pop().split('?')[0];
        return fileName.replace(/_\d+x\d+/g, '');
      };
      
      return getBaseName(url1) === getBaseName(url2);
    }
    
    // FUNCIÓN: ACTUALIZAR PRECIOS POR VARIANTE
    function updatePricesByVariant(selectedOption) {
      const productType = getProductType();
      
      // MANEJAR PRODUCTOS TIPO 3 (multicantidad con variantes)
      if (productType === 'dropdown_simple' || (productType === 'multi_cantidad' && getQuantityDisplayNames().length === 6)) {
        updatePricesByVariantType3(selectedOption);
        return;
      }
      
      // Lógica para TIPO 1 y TIPO 2 (arnés/cama)
      const variant = findVariantByOption(selectedOption);
      
      if (variant) {
        const discountPercentage = getDiscountPercentage();
        const variantWithCompare = {...variant};
        
        if (!variantWithCompare.compare_at_price && discountPercentage > 0) {
          variantWithCompare.compare_at_price = calculateCompareAtPrice(variant.price, discountPercentage);
        }
        
        updatePriceNumbers(variantWithCompare);
        updateShopifyPrice(variant);
      }
    }

    // FUNCIÓN: MANEJAR CAMBIO DE VARIANTE PARA PRODUCTOS TIPO 3
    function updatePricesByVariantType3(selectedOption) {
      const quantityDisplayNames = getQuantityDisplayNames();
      const quantityImages = getQuantityImages();
      
      if (!quantityDisplayNames || quantityDisplayNames.length !== 6) {
        return;
      }
      
      const dropdownOptions = Array.from(document.querySelectorAll('.dropdown-option')).map(option => 
        option.getAttribute('data-value')
      );
      
      let selectedVariantGroup = 0;
      
      if (dropdownOptions && dropdownOptions.length > 0) {
        const optionIndex = dropdownOptions.findIndex(option => option === selectedOption);
        if (optionIndex !== -1) {
          selectedVariantGroup = optionIndex;
        }
      }
      
      const startIndex = selectedVariantGroup * 3;
      const selectedQuantityNames = quantityDisplayNames.slice(startIndex, startIndex + 3);
      const selectedQuantityImages = quantityImages.slice(startIndex, startIndex + 3);
      
      recreateQuantitySelectorType3(selectedQuantityNames, selectedQuantityImages);
    }
    
    // FUNCIÓN: RECREAR SELECTOR DE CANTIDAD PARA TIPO 3
    function recreateQuantitySelectorType3(quantityNames, quantityImages) {
      const quantitySelectorContainer = document.getElementById('quantitySelector');
      if (!quantitySelectorContainer) {
        return;
      }
      
      const currentlyActiveOption = quantitySelectorContainer.querySelector('.quantity-option.active');
      const previouslySelectedQuantity = currentlyActiveOption 
        ? parseInt(currentlyActiveOption.getAttribute('data-quantity')) 
        : 1;
      
      quantitySelectorContainer.innerHTML = '';
      
      let quantitySelectorHTML = '';
      
      for (let i = 0; i < 3; i++) {
        const quantity = i + 1;
        const isActive = quantity === previouslySelectedQuantity;
        const saveBadge = quantity > 1 ? `<span class="save-badge">Ahorra ${quantity === 2 ? '10' : '20'}%</span>` : '';
        
        quantitySelectorHTML += `
          <div class="quantity-option ${isActive ? 'active' : ''}" data-quantity="${quantity}">
            <div class="quantity-images">
              <img src="${quantityImages[i] || quantityImages[0]}" alt="${quantityNames[i]}" />
            </div>
            <span class="quantity-text">${quantityNames[i]}</span>
            ${saveBadge}
          </div>
        `;
      }
      
      quantitySelectorContainer.innerHTML = quantitySelectorHTML;
      
      const quantityOptions = quantitySelectorContainer.querySelectorAll('.quantity-option');
      quantityOptions.forEach(option => {
        option.addEventListener('click', function() {
          const selectedQuantity = parseInt(this.dataset.quantity);
          updatePricesByQuantity(selectedQuantity);
          
          quantityOptions.forEach(opt => opt.classList.remove('active'));
          this.classList.add('active');
        });
      });
      
      updatePricesByQuantity(previouslySelectedQuantity);
    }
    
    // FUNCIÓN: ENCONTRAR VARIANTE POR OPCIÓN
    function findVariantByOption(selectedOption) {
      if (!productData.product || !productData.product.variants) {
        return null;
      }
      
      let realVariantName = selectedOption;
      if (selectedOption.includes('|')) {
        realVariantName = selectedOption.split('|')[1].trim();
      }
      
      let foundVariant = productData.product.variants.find(variant => {
        if (!variant) return false;
        
        const variantNames = [
          variant.option1,
          variant.option2, 
          variant.option3,
          variant.title
        ].filter(Boolean).map(name => name.trim().toLowerCase());
        
        const searchName = realVariantName.toLowerCase().trim();
        
        return variantNames.some(name => name === searchName);
      });
      
      if (foundVariant) {
        return foundVariant;
      }
      
      // FALLBACK: Sistema por posición
      const dropdownOptions = Array.from(document.querySelectorAll('.dropdown-option')).map(opt => 
        opt.getAttribute('data-value')
      );
      
      if (dropdownOptions.length === productData.product.variants.length) {
        const selectedIndex = dropdownOptions.indexOf(selectedOption);
        
        if (selectedIndex !== -1 && selectedIndex < productData.product.variants.length) {
          return productData.product.variants[selectedIndex];
        }
      }
      
      return null;
    }

    // FUNCIÓN: MOSTRAR ENVÍO EN MÓVIL
    function mostrarEnvioMovil() {
      if (window.innerWidth > 768) return;
      
      const tipoProducto = getProductType();
      
      let shippingContent = '';
      
      if (tipoProducto === 'arnes') {
        const deliveryDate = calculateDeliveryDate();
        /*shippingContent = `
          <div class="shipping-text">
            <div class="shipping-title">ENVÍO GRATIS</div>
            <div class="shipping-date with-dot">Se envía antes del <strong>${deliveryDate}</strong></div>
          </div>
        `;*/
        shippingContent = `
          <div class="shipping-text">
            <div class="shipping-title">ENVÍO GRATIS</div>
            <div class="shipping-date">En Pedidos Superiores A 40€</div>
          </div>
        `;
      } else {
        shippingContent = `
          <div class="shipping-text">
            <div class="shipping-title">ENVÍO GRATIS</div>
            <div class="shipping-date">En Pedidos Superiores A 40€</div>
          </div>
        `;
      }
      
      const htmlEnvioMovil = `
        <div class="shipping-mobile-container">
          <img src="https://cdn.shopify.com/s/files/1/0959/1367/3042/files/spain_precios.png?v=1752486799" alt="España" class="shipping-flag" />
          ${shippingContent}
        </div>
      `;
      
      const existingShipping = document.querySelector('.shipping-mobile-container');
      if (existingShipping) {
        existingShipping.remove();
      }
      
      if (tipoProducto === 'arnes') {
        const bonusContainer = document.querySelector('.bonus-block');
        if (bonusContainer) {
          bonusContainer.insertAdjacentHTML('afterend', htmlEnvioMovil);
        }
      } else {
        const priceContainer = document.querySelector('.price-container-main');
        if (priceContainer) {
          priceContainer.insertAdjacentHTML('afterend', htmlEnvioMovil);
        }
      }
    }
    
    // FUNCIÓN: ACTUALIZAR NÚMEROS DE PRECIO
    function updatePriceNumbers(variant) {
      const currentPriceElement = document.getElementById('currentPrice');
      const retailPriceElement = document.getElementById('retailPrice');
      const discountBadge = document.getElementById('discountBadge');
      const productType = getProductType();

      if (currentPriceElement) {
        const formattedPrice = formatPrice(variant.price);
        currentPriceElement.textContent = formattedPrice;
      }

      if (retailPriceElement && variant.compare_at_price && variant.compare_at_price > variant.price) {
        const formattedRetailPrice = formatPrice(variant.compare_at_price);
        retailPriceElement.textContent = formattedRetailPrice;
        retailPriceElement.style.display = 'inline';
      } else if (retailPriceElement) {
        retailPriceElement.style.display = 'none';
      }

      const discountBadgeTop = document.getElementById('discountBadgeTop');
      if (shouldShowDiscountBadge(productType, 1, variant)) {
        updateDiscountBadge(discountBadgeTop, variant, productType);
      } else if (discountBadgeTop) {
        discountBadgeTop.style.display = 'none';
      }

      if (discountBadge && variant.compare_at_price && variant.compare_at_price > variant.price) {
        const savings = variant.compare_at_price - variant.price;

        // % mostrado: fijo para arnés/cama; calculado para el resto
        const cfg = getDiscountPercentage(); // 20 arnés / 15 cama / 0 otros
        const percentage =
          ((productType === 'arnes' || productType === 'dropdown_descuento') && cfg > 0)
            ? cfg
            : Math.round((savings / variant.compare_at_price) * 100);

        const discountText = discountBadge.querySelector('.discount-text');
        if (discountText) {
          discountText.innerHTML = `¡AHORRA <span class="discount-amount">${formatPrice(savings)}</span> (${percentage}%)!`;
        }
        discountBadge.style.display = 'block';
      } else if (discountBadge) {
        discountBadge.style.display = 'none';
      }
    }

    
    // FUNCIÓN: VERIFICAR SI MOSTRAR RECUADRO ROJO
    function shouldShowDiscountBadge(productType, selectedQuantity, variant) {
      switch(productType) {
        case 'arnes':
          return variant && variant.compare_at_price && variant.compare_at_price > variant.price;
          
        case 'dropdown_descuento':
          return variant && variant.compare_at_price && variant.compare_at_price > variant.price;
          
        case 'dropdown_simple':
          return false;
          
        case 'multi_cantidad':
          return selectedQuantity > 1;
          
        default:
          return false;
      }
    }
    
    // FUNCIÓN: ACTUALIZAR RECUADRO ROJO
    function updateDiscountBadge(discountBadgeElement, variant, productType) {
      if (!discountBadgeElement || !variant) return;

      const savings = variant.compare_at_price - variant.price;

      // % mostrado: fijo para arnés/cama; calculado para el resto
      const cfg = getDiscountPercentage(); // 20 arnés / 15 cama / 0 otros
      const percentage =
        ((productType === 'arnes' || productType === 'dropdown_descuento') && cfg > 0)
          ? cfg
          : Math.round((savings / variant.compare_at_price) * 100);

      const discountAmountTop = discountBadgeElement.querySelector('.discount-amount-top');
      const discountPercentageTop = discountBadgeElement.querySelector('.discount-percentage-top');

      if (discountAmountTop) discountAmountTop.textContent = formatPrice(savings);
      if (discountPercentageTop) discountPercentageTop.textContent = percentage + '%';

      discountBadgeElement.style.display = 'block';
    }

    
    // FUNCIÓN: RENDERIZAR LAYOUT ARNÉS
    function renderArnesLayout() {
      const targetContainer = findPriceContainer();
      if (!targetContainer) return;
      
      const arnesHTML = `
        <div class="custom-price-container arnes-layout">
          <div class="discount-badge-top" id="discountBadgeTop" style="display: none;">
            DESCUENTO <span class="discount-amount-top">0€</span> (<span class="discount-percentage-top">0%</span>)
          </div>
          
          <div class="price-container-main">
            <div class="price-section-left">
              <div class="price-item">
                <div class="price-label">Precio Especial:</div>
                <div class="price-value" id="currentPrice">0€</div>
              </div>
              <div class="price-item">
                <div class="price-label">Antes:</div>
                <div class="price-value-crossed" id="retailPrice">0€</div>
              </div>
            </div>
            
            <div class="shipping-section-right">
              <div class="shipping-flag-container">
                <img src="https://cdn.shopify.com/s/files/1/0959/1367/3042/files/spain_precios.png?v=1752486799" alt="España" class="shipping-flag" />
                <div class="shipping-text">
                  <div class="shipping-title">ENVÍO GRATIS</div>
                  <div class="shipping-date" id="deliveryDate">Sale antes del</div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="bonus-block">
            <div class="bonus-count-floating">BONUS 1</div>
            <div class="bonus-badge-floating">MIENTRAS HAYA EXISTENCIAS</div>
            <div class="bonus-purchased-text">465 Regalados El Mes Pasado</div>
            
            <div class="bonus-content">
              <div class="bonus-image">
                <img src="https://cdn.shopify.com/s/files/1/0959/1367/3042/files/free-soft-touch.webp?v=1752321285" alt="Correa gratis" class="bonus-product-image" />
              </div>
              <div class="bonus-details">
                <div class="bonus-line1">¡Llévate un Regalo Gratis</div>
                <div class="bonus-line2">Con Tu Arnés!</div>
                <div class="bonus-subtitle">Correa Para Perros</div>
              </div>
              <div class="bonus-prices">
                <span class="bonus-retail">17.95€</span>
                <span class="bonus-free-price">0.0€</span>
                <span class="free-badge">¡GRATIS!</span>
              </div>
            </div>
          </div>
        </div>
      `;
      
      if (targetContainer.querySelector('.custom-price-container')) {
        targetContainer.innerHTML = arnesHTML;
      } else {
        targetContainer.insertAdjacentHTML('beforeend', arnesHTML);
      }

      setTimeout(function() {
        mostrarEnvioMovil();
      }, 250);
    }
    
    // FUNCIÓN: RENDERIZAR LAYOUT DROPDOWN
    function renderDropdownLayout() {
      const targetContainer = findPriceContainer();
      if (!targetContainer) return;
      
      const dropdownHTML = `
        <div class="custom-price-container dropdown-layout">
          <div class="discount-badge-top" id="discountBadgeTop" style="display: none;">
            DESCUENTO <span class="discount-amount-top">0€</span> (<span class="discount-percentage-top">0%</span>)
          </div>
          
          <div class="price-container-main">
            <div class="price-section-left">
              <div class="price-item">
                <div class="price-label">Precio Especial:</div>
                <div class="price-value" id="currentPrice">0€</div>
              </div>
              <div class="price-item">
                <div class="price-label">Antes:</div>
                <div class="price-value-crossed" id="retailPrice">0€</div>
              </div>
            </div>
            
            <div class="shipping-section-right">
              <div class="shipping-flag-container">
                <img src="https://cdn.shopify.com/s/files/1/0959/1367/3042/files/spain_precios.png?v=1752486799" alt="España" class="shipping-flag" />
                <div class="shipping-text">
                  <div class="shipping-title">ENVÍO GRATIS</div>
                  <div class="shipping-date" id="deliveryDate">Sale antes del</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      
      if (targetContainer.querySelector('.custom-price-container')) {
        targetContainer.innerHTML = dropdownHTML;
      } else {
        targetContainer.insertAdjacentHTML('beforeend', dropdownHTML);
      }

      setTimeout(function() {
        mostrarEnvioMovil();
      }, 250);
    }
    
    // FUNCIÓN: RENDERIZAR LAYOUT MULTI-CANTIDAD
    function renderMultiQuantityLayout() {
      const targetContainer = findPriceContainer();
      if (!targetContainer) return;
      
      const multiQuantityHTML = `
        <div class="custom-price-container multi-quantity-layout">
          <div class="quantity-selector" id="quantitySelector">
            <!-- Se generará dinámicamente -->
          </div>
          
          <div class="discount-badge-top" id="discountBadgeTop" style="display: none;">
            DESCUENTO <span class="discount-amount-top">0€</span> (<span class="discount-percentage-top">0%</span>)
          </div>
          
          <div class="price-container-main">
            <div class="price-section-left">
              <div class="price-item">
                <div class="price-label">Precio Especial:</div>
                <div class="price-value" id="currentPrice">0€</div>
              </div>
              <div class="price-item">
                <div class="price-label">Antes:</div>
                <div class="price-value-crossed" id="retailPrice">0€</div>
              </div>
            </div>
            
            <div class="shipping-section-right">
              <div class="shipping-flag-container">
                <img src="https://cdn.shopify.com/s/files/1/0959/1367/3042/files/spain_precios.png?v=1752486799" alt="España" class="shipping-flag" />
                <div class="shipping-text">
                  <div class="shipping-title">ENVÍO GRATIS</div>
                  <div class="shipping-date" id="deliveryDate">Sale antes del</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      
      if (targetContainer.querySelector('.custom-price-container')) {
        targetContainer.innerHTML = multiQuantityHTML;
      } else {
        targetContainer.insertAdjacentHTML('beforeend', multiQuantityHTML);
      }
      
      setTimeout(() => {
        const discountBadge = document.getElementById('discountBadgeTop');
        
        if (discountBadge) {
          discountBadge.style.display = 'none';
        }
        
        createQuantitySelector();
        
        setTimeout(function() {
          mostrarEnvioMovil();
        }, 250);
        
      }, 10);
    }
    
    // FUNCIÓN: CREAR SELECTOR DE CANTIDAD
    function createQuantitySelector() {
      const quantitySelectorContainer = document.getElementById('quantitySelector');
      if (!quantitySelectorContainer) return;
      
      const quantityImages = getQuantityImages();
      const quantityNames = getQuantityDisplayNames();
      
      const quantitySelectorHTML = `
        <div class="quantity-option active" data-quantity="1">
          <div class="quantity-images">
            <img src="${quantityImages[0]}" alt="${quantityNames[0]}" />
          </div>
          <span class="quantity-text">${quantityNames[0]}</span>
        </div>
        <div class="quantity-option" data-quantity="2">
          <div class="quantity-images">
            <img src="${quantityImages[1]}" alt="${quantityNames[1]}" />
          </div>
          <span class="quantity-text">${quantityNames[1]}</span>
          <span class="save-badge">Ahorra 10%</span>
        </div>
        <div class="quantity-option" data-quantity="3">
          <div class="quantity-images">
            <img src="${quantityImages[2]}" alt="${quantityNames[2]}" />
          </div>
          <span class="quantity-text">${quantityNames[2]}</span>
          <span class="save-badge">Ahorra 20%</span>
        </div>
      `;
      
      quantitySelectorContainer.innerHTML = quantitySelectorHTML;
      
      const quantityOptions = quantitySelectorContainer.querySelectorAll('.quantity-option');
      quantityOptions.forEach(option => {
        option.addEventListener('click', function() {
          const selectedQuantity = parseInt(this.dataset.quantity);
          updatePricesByQuantity(selectedQuantity);
          
          quantityOptions.forEach(opt => opt.classList.remove('active'));
          this.classList.add('active');
        });
      });
      
      updatePricesByQuantity(1);
    }

    // FUNCIÓN: OBTENER IMÁGENES DE CANTIDAD DEL METACAMPO
    function getQuantityImages() {
      const quantityImagesElement = document.querySelector('[data-quantity-images]');
      let images = [];
      
      if (quantityImagesElement && quantityImagesElement.dataset.quantityImages) {
        const imagesData = quantityImagesElement.dataset.quantityImages;
        images = imagesData.split('|').map(img => img.trim()).filter(img => img.length > 0);
      }
      
      const fallbackImage = getMainProductImage();
      while (images.length < 3) {
        images.push(fallbackImage);
      }
      
      return images;
    }

    // FUNCIÓN: OBTENER NOMBRES DE CANTIDAD DEL METACAMPO
    function getQuantityDisplayNames() {
      const quantityNamesElement = document.querySelector('[data-quantity-display-names]');
      let names = [];
      
      if (quantityNamesElement && quantityNamesElement.dataset.quantityDisplayNames) {
        const namesData = quantityNamesElement.dataset.quantityDisplayNames;
        names = namesData.split('\n').map(name => name.trim()).filter(name => name.length > 0);
      }
      
      const fallbackName = getProductName();
      while (names.length < 3) {
        const quantity = names.length + 1;
        if (quantity === 1) {
          names.push(`1 ${fallbackName}`);
        } else {
          names.push(`${quantity} ${fallbackName}s`);
        }
      }
      
      return names;
    }

    // FUNCIÓN: OBTENER IMAGEN PRINCIPAL DEL PRODUCTO
    function getMainProductImage() {
      const mainImage = document.querySelector('.product__media img') || 
                       document.querySelector('.product-single__photo img') ||
                       document.querySelector('img[src*="cdn.shopify"]');
      return mainImage ? mainImage.src : 'https://via.placeholder.com/150';
    }
    
    // FUNCIÓN: OBTENER NOMBRE DEL PRODUCTO
    function getProductName() {
      const titleElement = document.querySelector('.product__title') ||
                          document.querySelector('h1') ||
                          document.querySelector('.product-single__title');
      return titleElement ? titleElement.textContent.trim() : 'Product';
    }
    
    // FUNCIÓN: ACTUALIZAR PRECIOS POR CANTIDAD
    function updatePricesByQuantity(selectedQuantity) {
      const baseVariant = productData.product.variants[0];
      const basePrice = baseVariant.price;
      
      let finalPrice, originalPrice;
      
      switch(selectedQuantity) {
        case 1:
          finalPrice = basePrice;
          originalPrice = basePrice;
          break;
        case 2:
          originalPrice = basePrice * 2;
          finalPrice = Math.round(originalPrice * 0.9);
          break;
        case 3:
          originalPrice = basePrice * 3;
          finalPrice = Math.round(originalPrice * 0.8);
          break;
        default:
          finalPrice = basePrice;
          originalPrice = basePrice;
      }
      
      const currentPriceElement = document.getElementById('currentPrice');
      const retailPriceElement = document.getElementById('retailPrice');
      
      if (currentPriceElement) {
        currentPriceElement.textContent = formatPrice(finalPrice);
      }
      
      if (retailPriceElement) {
        retailPriceElement.textContent = formatPrice(originalPrice);
        retailPriceElement.style.display = 'inline';
      }
    
      const discountBadgeTop = document.getElementById('discountBadgeTop');
      const priceContainer = document.querySelector('.price-container-main');
    
      if (discountBadgeTop && priceContainer) {
        if (selectedQuantity > 1) {
          const savings = originalPrice - finalPrice;
          const percentage = Math.round((savings / originalPrice) * 100);
          
          const discountAmountTop = discountBadgeTop.querySelector('.discount-amount-top');
          const discountPercentageTop = discountBadgeTop.querySelector('.discount-percentage-top');
          
          if (discountAmountTop) discountAmountTop.textContent = formatPrice(savings);
          if (discountPercentageTop) discountPercentageTop.textContent = percentage + '%';
          
          discountBadgeTop.style.display = 'block';
          discountBadgeTop.style.visibility = 'visible';
          discountBadgeTop.style.opacity = '1';
          
          priceContainer.appendChild(discountBadgeTop);
        } else {
          discountBadgeTop.style.display = 'none';
          discountBadgeTop.style.visibility = 'hidden';
        }
      }
    }
    
    // FUNCIÓN: RENDERIZAR LAYOUT SIMPLE
    function renderSimpleLayout() {
      const targetContainer = findPriceContainer();
      if (!targetContainer) return;
      
      const simpleHTML = `
        <div class="custom-price-container simple-layout">
          <div class="price-block">
            <div class="price-section">
              <div class="price-labels">
                <span class="price-label">Tu Precio:</span>
              </div>
              <div class="price-values">
                <span class="current-price" id="currentPrice">0€</span>
              </div>
            </div>
            
            <div class="shipping-info">
              <div class="shipping-badge">
                <img src="https://cdn.shopify.com/s/files/1/0959/1367/3042/files/spain.png?v=1752321083" alt="España" class="flag-spain" />
                <div class="shipping-text">
                  <strong>ENVÍO GRATIS</strong>
                  <div class="delivery-date" id="deliveryDate">Se envía antes del</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      
      if (targetContainer.querySelector('.custom-price-container')) {
        targetContainer.innerHTML = simpleHTML;
      } else {
        targetContainer.insertAdjacentHTML('beforeend', simpleHTML);
      }

      setTimeout(function() {
        mostrarEnvioMovil();
      }, 250);
    }
    
    // FUNCIÓN: ENCONTRAR CONTENEDOR DE PRECIO
    function findPriceContainer() {
      const rightCol = document.querySelector('.product__info-wrapper');
      if (!rightCol) return null;

      const host =
        rightCol.querySelector('.main-product__info-container') ||
        rightCol.querySelector('product-info') ||
        rightCol;

      let container = host.querySelector('.custom-price-insertion');
      if (!container) {
        container = document.createElement('div');
        container.className = 'custom-price-insertion';
      }

      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      const isArnes =
        /\/arnes(\/|$)/.test(location.pathname) ||
        document.body.classList.contains('product-handle-arnes');

      const desktopAnchors = isArnes
        ? [
            '.custom-size-selector',
            '.size-chart-container',
            '.selector-personalizado',
            '.product-features-block',
            '.customer-review-block',
            '.custom-featured-text'
          ]
        : [
            '.product-features-block',
            '.customer-review-block',
            '.custom-featured-text',
            '.size-chart-container',
            '.custom-size-selector',
            '.selector-personalizado'
          ];

      const buyNow = host.querySelector('.comprar-ahora-container');

      const pick = (selectors) => {
        for (const s of selectors) {
          const n = host.querySelector(s);
          if (n) return n;
        }
        return null;
      };

      if (isDesktop) {
        const after = pick(desktopAnchors);
        if (after && after.parentNode) {
          if (after.nextSibling) {
            after.parentNode.insertBefore(container, after.nextSibling);
          } else {
            after.parentNode.appendChild(container);
          }
        } else {
          if (buyNow && buyNow.parentNode) {
            buyNow.parentNode.insertBefore(container, buyNow);
          } else {
            host.appendChild(container);
          }
        }

        if (buyNow) {
          const mask = container.compareDocumentPosition(buyNow);
          if (mask & Node.DOCUMENT_POSITION_PRECEDING) {
            buyNow.parentNode.insertBefore(container, buyNow);
          }
        }
      } else {
        if (!container.parentNode) {
          if (buyNow && buyNow.parentNode) {
            buyNow.parentNode.insertBefore(container, buyNow);
          } else {
            host.appendChild(container);
          }
        }
      }

      return container;
    }
    
    // FUNCIÓN: ACTUALIZAR FECHA DE ENVÍO
    function updateDeliveryDate() {
      setTimeout(function() {
        const deliveryElement = document.getElementById('deliveryDate');
        
        if (deliveryElement) {
          const tipoProducto = getProductType();
          
          if (tipoProducto === 'arnes') {
            /*const deliveryDate = calculateDeliveryDate();
            deliveryElement.innerHTML = `Se envía antes del <strong>${deliveryDate}</strong>`;
            deliveryElement.classList.add('with-dot');*/
            //provisional
            deliveryElement.innerHTML = `En Pedidos Superiores A 40€`;
            deliveryElement.classList.remove('with-dot');
          } else {
            deliveryElement.innerHTML = `En Pedidos Superiores A 40€`;
            deliveryElement.classList.remove('with-dot');
          }
        }
      }, 200);
    }
    
    // FUNCIÓN: CALCULAR FECHA DE ENVÍO
    function calculateDeliveryDate() {
      const today = new Date();
      const deliveryDate = new Date(today);
      deliveryDate.setDate(today.getDate() + 2);
      
      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      return deliveryDate.toLocaleDateString('es-ES', options);
    }
    
    // FUNCIÓN: ACTUALIZAR PRECIO NATIVO DE SHOPIFY
    function updateShopifyPrice(variant) {
      const variantIdInput = document.querySelector('[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      const variantChangeEvent = new CustomEvent('variant:change', {
        detail: { variant: variant }
      });
      document.dispatchEvent(variantChangeEvent);
    }
    
    // FUNCIÓN: FORMATEAR PRECIO EN EUROS
    function formatPrice(priceInCents) {
      if (!priceInCents || isNaN(priceInCents)) {
        return '0.00€';
      }
      const price = priceInCents / 100;
      return `${price.toFixed(2)}€`;
    }
    
    // FUNCIÓN: OBTENER PRIMERA VARIANTE DISPONIBLE
    function getFirstAvailableVariant() {
      if (!productData.product || !productData.product.variants) {
        return null;
      }
      
      return productData.product.variants.find(variant => variant.available) || 
             productData.product.variants[0];
    }
    
    // INICIALIZAR PRECIOS CON PRIMERA VARIANTE
    setTimeout(function() {
      if (productData.product) {
        const productType = getProductType();
        
        if ((productType === 'arnes' || productType === 'dropdown_descuento' || productType === 'dropdown_simple') 
            && document.querySelector('.dropdown-option')) {
          
          const firstDropdownOption = document.querySelector('.dropdown-option');
          if (firstDropdownOption) {
            const firstOptionValue = firstDropdownOption.getAttribute('data-value');
            
            const selectedText = document.querySelector('.selected-text');
            if (selectedText && firstOptionValue) {
              let displayValue = firstOptionValue;
              if (firstOptionValue.includes('|')) {
                displayValue = firstOptionValue.split('|')[0].trim();
              }
              selectedText.textContent = displayValue;
            }
            
            firstDropdownOption.classList.add('selected');
            updatePricesByVariant(firstOptionValue);
          }
        } else if (productType === 'multi_cantidad') {
          updatePricesByQuantity(1);
        } else {
          const firstVariant = getFirstAvailableVariant();
          if (firstVariant) {
            updatePriceNumbers(firstVariant);
          }
        }
        
        updateDeliveryDate();
      }
    }, 600);
    
  }, 500);
});

// =================================
// BUNDLE DE PRODUCTOS - VERSIÓN SIMPLIFICADA
// =================================

let globalBundleProductsData = [];

document.addEventListener('DOMContentLoaded', function() {
  waitForElement('.product__info-wrapper', function() {
    if (document.querySelector('.bundle-products-container')) {
      initializeBundleProducts();
    }
  }, 1200);
});

// FUNCIÓN: INICIALIZAR BUNDLE DE PRODUCTOS
function initializeBundleProducts() {
  const bundleContainer = document.querySelector('.bundle-products-container');
  if (!bundleContainer) {
    return;
  }
  
  const currentProductHandle = document.querySelector('[data-current-product]')?.getAttribute('data-current-product');
  const related1Handle = document.querySelector('[data-bundle-related-1]')?.getAttribute('data-bundle-related-1');
  const related2Handle = document.querySelector('[data-bundle-related-2]')?.getAttribute('data-bundle-related-2');
  
  const bundleProducts = [];
  
  if (currentProductHandle) {
    bundleProducts.push({
      handle: currentProductHandle,
      isCurrentProduct: true
    });
  }
  
  if (related1Handle && related1Handle.trim() !== '') {
    bundleProducts.push({
      handle: related1Handle,
      isCurrentProduct: false
    });
  }
  
  if (related2Handle && related2Handle.trim() !== '') {
    bundleProducts.push({
      handle: related2Handle,
      isCurrentProduct: false
    });
  }
  
  if (bundleProducts.length === 0) {
    bundleContainer.style.display = 'none';
    return;
  }
  
  Promise.all(bundleProducts.map(item => getBundleProductData(item)))
    .then(productsData => {
      buildBundleInterface(productsData);
    })
    .catch(error => {
      bundleContainer.style.display = 'none';
    });
}

// FUNCIÓN: OBTENER DATOS DE UN PRODUCTO DEL BUNDLE
function getBundleProductData(productItem) {
  return new Promise((resolve) => {
    const { handle, isCurrentProduct } = productItem;
    
    if (isCurrentProduct) {
      const currentProduct = getCurrentProductComplete();
      const bundleProductType = getBundleProductTypeAdvanced(handle, currentProduct);
      
      const data = {
        handle: handle,
        name: document.querySelector('[data-current-product-name]')?.getAttribute('data-current-product-name')?.replace(/^NexoCan®?\s*/i, '').trim() || (currentProduct ? currentProduct.title : 'Producto Actual'),
        image: getBundleProductImage(currentProduct, handle),
        type: bundleProductType,
        basePrice: currentProduct ? (
          (currentProduct.variants && (currentProduct.variants.length === 3 || currentProduct.variants.length === 6)) 
            ? currentProduct.variants[0].price 
            : (currentProduct.price || currentProduct.variants?.[0]?.price)
        ) : 5596,
        currentVariant: currentProduct ? currentProduct.variants[0] : { id: 1, price: currentProduct?.variants?.[0]?.price || 5596 },
        variants: getBundleProductVariantsAdvanced(currentProduct, bundleProductType, handle, {
          quantityDisplayNames: document.querySelector('[data-quantity-display-names]')?.dataset.quantityDisplayNames?.split('\n').filter(name => name.trim() !== '') || null,
          sizeOptions: document.querySelector('[data-size-options]')?.dataset.sizeOptions || null
        }, true),
        discountType: getDiscountType(bundleProductType),
        discountPercentage: getDiscountPercentage(bundleProductType),
        selectedQuantity: 1,
        selectedVariantIndex: 0,
        isCurrentProduct: true
      };
      
      resolve(data);
    } else {
      fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(product => {
          return fetch(`/products/${handle}`)
            .then(htmlResponse => htmlResponse.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              const bundleProductType = getBundleProductTypeFromHTML(doc, handle);
              const quantityImages = getBundleQuantityImagesFromHTML(doc);
              const quantityDisplayNames = getBundleQuantityDisplayNamesFromHTML(doc);
              const sizeOptions = getBundleSizeOptionsFromHTML(doc);
              const discountPercentage = getBundleDiscountFromHTML(doc);
              
              const data = {
                handle: handle,
                name: getBundleRelatedProductName(handle) || getBundleProductName(product),
                image: quantityImages && quantityImages[0] ? quantityImages[0] : getBundleProductImage(product, handle),
                type: bundleProductType,
                basePrice: (product.variants && (product.variants.length === 3 || product.variants.length === 6)) 
                  ? product.variants[0].price 
                  : product.price,
                currentVariant: product.variants[0],
                variants: getBundleProductVariantsAdvanced(product, bundleProductType, handle, { quantityDisplayNames, sizeOptions }, false),
                discountType: getDiscountType(bundleProductType),
                discountPercentage: discountPercentage || getDiscountPercentage(bundleProductType),
                selectedQuantity: 1,
                selectedVariantIndex: 0,
                isCurrentProduct: false,
                quantityDisplayNames: quantityDisplayNames,
                sizeOptions: sizeOptions
              };
              
              return data;
            });
        })
        .then(data => resolve(data))
        .catch(error => {
          const fallbackData = {
            handle: handle,
            name: getBundleRelatedProductName(handle) || 'Producto Relacionado',
            image: getBundleDefaultImage(handle),
            type: getBundleProductTypeBasic(handle),
            basePrice: 2395,
            currentVariant: { id: 1, price: 2395 },
            variants: getBundleMultiQuantityVariantsFallback(handle),
            discountType: 'quantity',
            discountPercentage: 0,
            selectedQuantity: 1,
            selectedVariantIndex: 0,
            isCurrentProduct: false
          };
          
          resolve(fallbackData);
        });
    }
  });
}

// FUNCIÓN: OBTENER PRODUCTO ACTUAL COMPLETO
function getCurrentProductComplete() {
  const productJsonScript = document.querySelector('script[data-product-json]');
  if (productJsonScript) {
    try {
      const jsonText = productJsonScript.textContent || productJsonScript.innerHTML;
      const product = JSON.parse(jsonText);
      if (product && product.variants) {
        return product;
      }
    } catch (e) {
      // Continuar
    }
  }
  
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
    return window.ShopifyAnalytics.meta.product;
  }
  
  if (window.product) {
    return window.product;
  }
  
  const allScripts = document.querySelectorAll('script[type="application/json"]');
  for (const script of allScripts) {
    try {
      const jsonText = script.textContent || script.innerHTML;
      const data = JSON.parse(jsonText);
      if (data && data.variants && Array.isArray(data.variants)) {
        return data;
      }
    } catch (e) {
      continue;
    }
  }
  
  return null;
}

// FUNCIÓN: DETECCIÓN AVANZADA DE TIPO DE PRODUCTO
function getBundleProductTypeAdvanced(handle, product, isCurrentProduct = true) {
  if (isCurrentProduct) {
    const metafieldElement = document.querySelector('[data-product-type]');
    if (metafieldElement) {
      const metafieldValue = metafieldElement.dataset.productType;
      
      if (metafieldValue === 'ninguno') return 'arnes';
      if (metafieldValue === 'dropdown_descuento') return 'cama';
      if (metafieldValue === 'dropdown_simple') return 'bebedero_guante_correa';
      
      if (metafieldValue === '') {
        const quantityNamesElement = document.querySelector('[data-quantity-display-names]');
        const quantityNamesCount = quantityNamesElement && quantityNamesElement.dataset.quantityDisplayNames ? 
          quantityNamesElement.dataset.quantityDisplayNames.split('\n').filter(name => name.trim() !== '').length : 0;
        
        if (quantityNamesCount === 6) {
          return 'multicantidad_con_variantes';
        } else {
          return 'multicantidad_simple';
        }
      }
    }
  }
  
  if (handle.includes('arnes')) return 'arnes';
  if (handle.includes('cama')) return 'cama';
  if (handle.includes('bebedero') || handle.includes('guante') || handle.includes('correa')) return 'multicantidad_con_variantes';
  
  return 'multicantidad_simple';
}

// FUNCIÓN: EXTRAER SIZE OPTIONS DEL HTML
function getBundleSizeOptionsFromHTML(doc) {
  const sizeOptionsElement = doc.querySelector('[data-size-options]');
  if (sizeOptionsElement && sizeOptionsElement.dataset.sizeOptions) {
    const optionsData = sizeOptionsElement.dataset.sizeOptions;
    const options = optionsData.split('\n').map(option => option.trim()).filter(option => option.length > 0);
    return options;
  }
  return null;
}

// FUNCIÓN: EXTRAER QUANTITY DISPLAY NAMES DEL HTML
function getBundleQuantityDisplayNamesFromHTML(doc) {
  const quantityNamesElement = doc.querySelector('[data-quantity-display-names]');
  if (quantityNamesElement && quantityNamesElement.dataset.quantityDisplayNames) {
    const namesData = quantityNamesElement.dataset.quantityDisplayNames;
    const names = namesData.split('\n').map(name => name.trim()).filter(name => name.length > 0);
    return names;
  }
  return null;
}

// FUNCIÓN: EXTRAER TIPO DE PRODUCTO DEL HTML
function getBundleProductTypeFromHTML(doc, handle) {
  const metafieldElement = doc.querySelector('[data-product-type]');
  if (metafieldElement) {
    const metafieldValue = metafieldElement.dataset.productType;
    
    if (metafieldValue === 'ninguno') return 'arnes';
    if (metafieldValue === 'dropdown_descuento') return 'cama';
    if (metafieldValue === 'dropdown_simple') return 'bebedero_guante_correa';
    
    if (metafieldValue === '') {
      const quantityNamesElement = doc.querySelector('[data-quantity-display-names]');
      const quantityNamesCount = quantityNamesElement && quantityNamesElement.dataset.quantityDisplayNames ? 
        quantityNamesElement.dataset.quantityDisplayNames.split('\n').filter(name => name.trim() !== '').length : 0;
      
      if (quantityNamesCount === 6) {
        return 'multicantidad_con_variantes';
      } else {
        return 'multicantidad_simple';
      }
    }
  }
  
  return getBundleProductTypeBasic(handle);
}

// FUNCIÓN: TIPO DE PRODUCTO BÁSICO POR HANDLE
function getBundleProductTypeBasic(handle) {
  if (handle.includes('arnes')) return 'arnes';
  if (handle.includes('cama')) return 'cama';  
  if (handle.includes('bebedero') || handle.includes('guante') || handle.includes('correa')) return 'multicantidad_con_variantes';
  return 'multicantidad_simple';
}

// FUNCIÓN: EXTRAER IMÁGENES DE CANTIDAD DEL HTML
function getBundleQuantityImagesFromHTML(doc) {
  const quantityImagesElement = doc.querySelector('[data-quantity-images]');
  if (quantityImagesElement && quantityImagesElement.dataset.quantityImages) {
    const imagesData = quantityImagesElement.dataset.quantityImages;
    return imagesData.split('\n').map(img => img.trim()).filter(img => img.length > 0);
  }
  return null;
}

// FUNCIÓN: EXTRAER DESCUENTO DEL HTML
function getBundleDiscountFromHTML(doc) {
  const discountElement = doc.querySelector('[data-discount-percentage]');
  if (discountElement) {
    const value = discountElement.dataset.discountPercentage;
    return parseInt(value) || 0;
  }
  return null;
}

// FUNCIÓN: CONSTRUIR VARIANTES AVANZADAS SEGÚN TIPO
function getBundleProductVariantsAdvanced(product, productType, handle, metacampos = null, isCurrentProduct = false) {
  switch(productType) {
    case 'arnes':
      return getBundleArnesVariants(product, handle);
      
    case 'cama':
      return getBundleCamaVariants(product, handle);
      
    case 'multicantidad_con_variantes':
      return getBundleMulticantidadConVariantesVariants(product, handle, metacampos);
      
    case 'multicantidad_simple':
    default:
      return getBundleMultiQuantityVariants(product, handle, metacampos?.quantityDisplayNames);
  }
}

// FUNCIÓN: VARIANTES DE ARNÉS - SIMPLIFICADA
function getBundleArnesVariants(product, handle) {
  const sizeMapping = {
    'S': 'Pequeña (8-13kg)',
    'M': 'Mediana (13-23kg)', 
    'L': 'Grande (20-32kg)',
    'XL': 'Extra Grande (32-60kg)'
  };
  
  if (product && product.variants && product.variants.length > 1) {
    return product.variants.map((variant) => {
      const publicTitle = variant.public_title || 'S';
      const name = sizeMapping[publicTitle] || `Talla ${publicTitle}`;
      const value = publicTitle;
      
      return {
        name: name,
        value: value,
        shopifyVariantId: variant.id,
        price: variant.price,
        comparePrice: variant.compare_at_price
      };
    });
  }
  
  const basePrice = product ? product.price : 4995;
  return [
    { name: 'Pequeña (8-13kg)', value: 'S', price: basePrice, comparePrice: null },
    { name: 'Mediana (13-23kg)', value: 'M', price: basePrice, comparePrice: null },
    { name: 'Grande (20-32kg)', value: 'L', price: basePrice, comparePrice: null },
    { name: 'Extra Grande (32-60kg)', value: 'XL', price: basePrice, comparePrice: null }
  ];
}

function getBundleCamaVariants(product, handle) {
  const sizeMapping = {
    '60cm': 'Pequeña (60cm)',
    '70cm': 'Mediana (70cm)', 
    '80cm': 'Grande (80cm)',
    '100cm': 'Extra Grande (100cm)',
    // Fallbacks por si usa otros formatos
    '60': 'Pequeña (60cm)',
    '70': 'Mediana (70cm)',
    '80': 'Grande (80cm)',
    '100': 'Extra Grande (100cm)'
  };
  
  if (product && product.variants && product.variants.length > 1) {
    return product.variants.map((variant) => {
      // Buscar el tamaño en option2 (que contiene "60cm", "70cm", etc.)
      const sizeOption = variant.option2 || variant.option1 || variant.public_title || '';
      
      // Extraer solo el número y cm
      const sizeMatch = sizeOption.match(/(\d+)cm?/);
      const sizeKey = sizeMatch ? `${sizeMatch[1]}cm` : sizeOption;
      
      const name = sizeMapping[sizeKey] || `Tamaño ${sizeOption}`;
      const value = sizeOption;
      
      return {
        name: name,
        value: value,
        shopifyVariantId: variant.id,
        price: variant.price,
        comparePrice: variant.compare_at_price
      };
    });
  }
  
  const basePrice = product ? product.price : 4995;
  return [
    { name: 'Pequeña (60cm)', value: '60cm', price: basePrice, comparePrice: null },
    { name: 'Mediana (70cm)', value: '70cm', price: basePrice, comparePrice: null },
    { name: 'Grande (80cm)', value: '80cm', price: basePrice, comparePrice: null },
    { name: 'Extra Grande (100cm)', value: '100cm', price: basePrice, comparePrice: null }
  ];
}

// FUNCIÓN CORREGIDA: MULTICANTIDAD CON VARIANTES
function getBundleMulticantidadConVariantesVariants(product, handle, metacampos) {
  const basePrice = product?.price || product?.variants?.[0]?.price || 2395;
  
  if (metacampos && metacampos.quantityDisplayNames && metacampos.quantityDisplayNames.length === 6) {
    return metacampos.quantityDisplayNames.map((name, index) => {
      const quantity = (index % 3) + 1;
      const variantGroup = Math.floor(index / 3);
      
      return {
        name: name,
        value: `${variantGroup}-${quantity}`,
        quantity: quantity,
        variantGroup: variantGroup,
        price: basePrice, // ✅ Solo precio base
        comparePrice: null // ✅ No pre-calcular
      };
    });
  }
  
  return getBundleMultiQuantityVariantsFallback(handle, basePrice);
}

// FUNCIÓN CORREGIDA: VARIANTES MULTICANTIDAD SIMPLE
function getBundleMultiQuantityVariants(product, handle, quantityDisplayNames = null) {
  const basePrice = product ? (product.price || product.variants?.[0]?.price) : 2395;
  
  if (quantityDisplayNames && quantityDisplayNames.length >= 3) {
    if (quantityDisplayNames.length === 6) {
      return quantityDisplayNames.map((name, index) => {
        const quantity = (index % 3) + 1;
        const variantGroup = Math.floor(index / 3);
        
        return {
          name: name,
          value: `${variantGroup}-${quantity}`,
          quantity: quantity,
          variantGroup: variantGroup,
          price: basePrice, // ✅ Solo almacenar el precio base, no pre-calcular
          comparePrice: null // ✅ No pre-calcular, se hará dinámicamente
        };
      });
    }
    
    return [
      { 
        name: quantityDisplayNames[0], 
        value: '1', 
        quantity: 1,
        price: basePrice, // ✅ Solo precio base
        comparePrice: null
      },
      { 
        name: quantityDisplayNames[1], 
        value: '2', 
        quantity: 2,
        price: basePrice, // ✅ Solo precio base
        comparePrice: null
      },
      { 
        name: quantityDisplayNames[2], 
        value: '3', 
        quantity: 3,
        price: basePrice, // ✅ Solo precio base
        comparePrice: null
      }
    ];
  }
  
  return getBundleMultiQuantityVariantsFallback(handle, basePrice);
}

// FUNCIÓN CORREGIDA: VARIANTES MULTICANTIDAD FALLBACK
function getBundleMultiQuantityVariantsFallback(handle, basePrice = 2395) {
  if (!basePrice || isNaN(basePrice)) {
    basePrice = 2395;
  }
  const productName = handle.includes('alfombra') ? 'Alfombrilla' : 
                     handle.includes('cinturon') ? 'Cinturón' :
                     handle.includes('bebedero') ? 'Bebedero' :
                     handle.includes('guante') ? 'Guante' : 
                     handle.includes('correa') ? 'Correa' : 'Producto';
  
  return [
    { 
      name: `1 ${productName}`, 
      value: '1', 
      quantity: 1,
      price: basePrice, // ✅ Solo precio base
      comparePrice: null
    },
    { 
      name: `2 ${productName}s`, 
      value: '2', 
      quantity: 2,
      price: basePrice, // ✅ Solo precio base
      comparePrice: null
    },
    { 
      name: `3 ${productName}s`, 
      value: '3', 
      quantity: 3,
      price: basePrice, // ✅ Solo precio base
      comparePrice: null
    }
  ];
}

// FUNCIÓN: DETERMINAR TIPO DE DESCUENTO
function getDiscountType(productType) {
  switch(productType) {
    case 'arnes':
    case 'cama':
      return 'fixed';
    case 'multicantidad_con_variantes':
    case 'multicantidad_simple':
    default:
      return 'quantity';
  }
}

// FUNCIÓN: OBTENER PORCENTAJE DE DESCUENTO
function getDiscountPercentage(productType) {
  switch(productType) {
    case 'arnes':
      return 20;
    case 'cama':
      return 15;
    case 'multicantidad_con_variantes':
    case 'multicantidad_simple':
    default:
      return 0;
  }
}

// FUNCIÓN: EXTRAER IMAGEN DEL PRODUCTO
function getBundleProductImage(product, handle) {
  const quantityImages = getBundleProductQuantityImages(handle);
  if (quantityImages && quantityImages.length > 0) {
    return quantityImages[0];
  }
  
  if (product && product.images && product.images.length > 0) {
    return product.images[0];
  }
  
  return getBundleDefaultImage(handle);
}

// FUNCIÓN: OBTENER IMÁGENES DEL METACAMPO
function getBundleProductQuantityImages(handle) {
  if (handle === document.querySelector('[data-current-product]')?.getAttribute('data-current-product')) {
    const quantityImagesElement = document.querySelector('[data-quantity-images]');
    if (quantityImagesElement && quantityImagesElement.dataset.quantityImages) {
      const imagesData = quantityImagesElement.dataset.quantityImages;
      return imagesData.split('\n').map(img => img.trim()).filter(img => img.length > 0);
    }
  }
  
  return null;
}

// FUNCIÓN: IMAGEN POR DEFECTO SEGÚN TIPO DE PRODUCTO
function getBundleDefaultImage(handle) {
  if (handle.includes('arnes')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/arnes-thumbnail.jpg';
  } else if (handle.includes('cama')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/cama-thumbnail.jpg';
  } else if (handle.includes('cinturon') || handle.includes('seguridad')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/cinturon-thumbnail.jpg';
  } else if (handle.includes('alfombra') || handle.includes('olfativa')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/alfombra-thumbnail.jpg';
  } else if (handle.includes('bebedero')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/bebedero-thumbnail.jpg';
  } else if (handle.includes('guante')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/guante-thumbnail.jpg';
  } else if (handle.includes('correa')) {
    return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/correa-thumbnail.jpg';
  }
  
  return 'https://cdn.shopify.com/s/files/1/0959/1367/3042/files/producto-thumbnail.jpg';
}

// FUNCIÓN: OBTENER NOMBRE DE PRODUCTO RELACIONADO
function getBundleRelatedProductName(handle) {
  if (handle === document.querySelector('[data-bundle-related-1]')?.getAttribute('data-bundle-related-1')) {
    return document.querySelector('[data-related-1-name]')?.getAttribute('data-related-1-name')?.replace(/^NexoCan®?\s*/i, '').trim();
  }
  if (handle === document.querySelector('[data-bundle-related-2]')?.getAttribute('data-bundle-related-2')) {
    return document.querySelector('[data-related-2-name]')?.getAttribute('data-related-2-name')?.replace(/^NexoCan®?\s*/i, '').trim();
  }
  return null;
}

// FUNCIÓN: EXTRAER NOMBRE DEL PRODUCTO
function getBundleProductName(product) {
  const title = product && product.title ? product.title : '';
  return title.replace(/^NexoCan®?\s*/i, '').trim();
}

// FUNCIÓN: CONSTRUIR INTERFAZ DEL BUNDLE
function buildBundleInterface(productsData) {
  globalBundleProductsData = productsData;
  
  const thumbnailsContainer = document.getElementById('bundleThumbnails');
  const checkboxesContainer = document.getElementById('bundleCheckboxes');
  
  if (!thumbnailsContainer || !checkboxesContainer) {
    return;
  }
  
  thumbnailsContainer.innerHTML = '';
  checkboxesContainer.innerHTML = '';
  
  productsData.forEach((product, index) => {
    createBundleCheckbox(product, index, checkboxesContainer);
  });
  
  updateBundleState(productsData);
  setupBundleButton();
}

// FUNCIÓN: CREAR CHECKBOX DE PRODUCTO
function createBundleCheckbox(product, index, container) {
  const isChecked = true;
  
  let dropdownOptions = '';
  
  switch(product.type) {
    case 'arnes':
    case 'cama':
      dropdownOptions = product.variants.map(variant => 
        `<option value="${variant.value}">${variant.name}</option>`
      ).join('');
      break;
      
    case 'multicantidad_con_variantes':
      dropdownOptions = product.variants.map(variant => 
        `<option value="${variant.value}">${variant.name}</option>`
      ).join('');
      break;
      
    case 'multicantidad_simple':
    default:
      dropdownOptions = product.variants.map(variant => 
        `<option value="${variant.value}">${variant.name}</option>`
      ).join('');
      break;
  }
  
  const checkboxHTML = `
    <div class="bundle-checkbox-item ${isChecked ? 'checked' : ''}" data-product-index="${index}">
      <div class="bundle-checkbox ${isChecked ? 'checked' : ''}" data-checkbox="${index}"></div>
      <div class="bundle-product-info">
        <span class="bundle-product-name">${product.name}</span>
        <select class="bundle-variant-dropdown" data-dropdown="${index}" ${!isChecked ? 'disabled' : ''}>
          ${dropdownOptions}
        </select>
      </div>
      <span class="bundle-item-price" data-price="${index}" data-product-type="${product.type}">
        ${formatBundlePrice({
          price: product.basePrice,
          quantity: 1
        }, product)}
      </span>
    </div>
  `;
  
  container.insertAdjacentHTML('beforeend', checkboxHTML);
  
  const checkboxElement = container.querySelector(`[data-checkbox="${index}"]`);
  const dropdownElement = container.querySelector(`[data-dropdown="${index}"]`);
  
  if (checkboxElement) {
    checkboxElement.addEventListener('click', () => {
      toggleBundleProduct(index);
    });
  }
  
  if (dropdownElement) {
    dropdownElement.addEventListener('change', (e) => {
      updateBundleProductPrice(index, e.target.value);
    });
  }
}

// FUNCIÓN: FORMATEAR PRECIO DEL BUNDLE
function formatBundlePrice(variant, product) {
  if (!variant || !product) {
    return '0.00€';
  }
  
  const priceData = calculateProductPrice(product, variant);
  
  if (priceData.hasDiscount) {
    return `${(priceData.finalPrice / 100).toFixed(2)}€ <span style="text-decoration: line-through; color: #999;">${(priceData.originalPrice / 100).toFixed(2)}€</span>`;
  } else {
    return `${(priceData.finalPrice / 100).toFixed(2)}€`;
  }
}

// FUNCIÓN CORREGIDA: CALCULAR PRECIO DEL PRODUCTO
function calculateProductPrice(product, selectedVariant) {
  if (!selectedVariant) {
    return { finalPrice: 0, originalPrice: 0, hasDiscount: false };
  }
  
  let finalPrice, originalPrice, hasDiscount = false;
  
  switch(product.type) {
    case 'arnes':
      finalPrice = selectedVariant.price || product.basePrice;
      originalPrice = Math.round(finalPrice * 1.20);
      hasDiscount = true;
      break;
      
    case 'cama':
      finalPrice = selectedVariant.price || product.basePrice;
      originalPrice = Math.round(finalPrice * 1.15);
      hasDiscount = true;
      break;
      
    case 'multicantidad_con_variantes':
    case 'multicantidad_simple':
    default:
      if (selectedVariant.quantity) {
        const quantity = selectedVariant.quantity;
        const basePrice = product.basePrice; // ✅ Usar siempre el precio base del producto
        
        if (quantity === 1) {
          finalPrice = basePrice;
          originalPrice = basePrice;
          hasDiscount = false;
        } else if (quantity === 2) {
          originalPrice = basePrice * 2;
          finalPrice = Math.round(originalPrice * 0.9); // -10%
          hasDiscount = true;
        } else if (quantity === 3) {
          originalPrice = basePrice * 3;
          finalPrice = Math.round(originalPrice * 0.8); // -20%
          hasDiscount = true;
        } else {
          finalPrice = basePrice * quantity;
          originalPrice = finalPrice;
          hasDiscount = false;
        }
      } else {
        finalPrice = selectedVariant.price || product.basePrice;
        originalPrice = finalPrice;
        hasDiscount = false;
      }
      break;
  }
  
  if (isNaN(finalPrice) || isNaN(originalPrice)) {
    return { finalPrice: 0, originalPrice: 0, hasDiscount: false };
  }
  
  const result = {
    finalPrice: finalPrice,
    originalPrice: originalPrice,
    hasDiscount: hasDiscount,
    formattedDisplay: hasDiscount 
      ? `${(finalPrice / 100).toFixed(2)}€ ~~${(originalPrice / 100).toFixed(2)}€~~`
      : `${(finalPrice / 100).toFixed(2)}€`
  };
  
  return result;
}

// FUNCIÓN: ACTUALIZAR PRECIO DE PRODUCTO DEL BUNDLE
function updateBundleProductPrice(productIndex, selectedValue) {
  const product = globalBundleProductsData[productIndex];
  if (!product) {
    return;
  }
  
  const selectedVariant = product.variants.find(variant => variant.value === selectedValue);
  if (!selectedVariant) {
    return;
  }
  
  const priceData = calculateProductPrice(product, selectedVariant);
  
  const priceElement = document.querySelector(`[data-price="${productIndex}"]`);
  if (priceElement) {
    if (priceData.hasDiscount) {
      priceElement.innerHTML = `${(priceData.finalPrice / 100).toFixed(2)}€ <span style="text-decoration: line-through; color: #999;">${(priceData.originalPrice / 100).toFixed(2)}€</span>`;
    } else {
      priceElement.innerHTML = `${(priceData.finalPrice / 100).toFixed(2)}€`;
    }
  }
  
  product.currentVariant = selectedVariant;
  if (selectedVariant.quantity) {
    product.selectedQuantity = selectedVariant.quantity;
  }
  
  updateBundlePrices();
}

// FUNCIÓN: ALTERNAR PRODUCTO EN BUNDLE
function toggleBundleProduct(index) {
  const item = document.querySelector(`[data-product-index="${index}"]`);
  const checkbox = document.querySelector(`[data-checkbox="${index}"]`);
  const dropdown = document.querySelector(`[data-dropdown="${index}"]`);
  
  if (!item || !checkbox || !dropdown) return;
  
  const isCurrentlyChecked = checkbox.classList.contains('checked');
  
  if (isCurrentlyChecked) {
    item.classList.remove('checked');
    checkbox.classList.remove('checked');
    dropdown.disabled = true;
    dropdown.style.opacity = '0.5';
  } else {
    item.classList.add('checked');
    checkbox.classList.add('checked');
    dropdown.disabled = false;
    dropdown.style.opacity = '1';
  }
  
  updateBundleState();
}

// FUNCIÓN: ACTUALIZAR ESTADO DEL BUNDLE
function updateBundleState(productsData = null) {
  updateBundleThumbnails();
  updateBundlePrices();
  updateBundleButton();
}

// FUNCIÓN: ACTUALIZAR MINIATURAS
function updateBundleThumbnails() {
  const thumbnailsContainer = document.getElementById('bundleThumbnails');
  if (!thumbnailsContainer) return;
  
  thumbnailsContainer.innerHTML = '';
  
  const checkedItems = document.querySelectorAll('.bundle-checkbox-item.checked');
  
  checkedItems.forEach((item, index) => {
    const productIndex = parseInt(item.getAttribute('data-product-index'));
    const productData = globalBundleProductsData[productIndex];
    
    if (!productData) {
      return;
    }
    
    if (index > 0) {
      thumbnailsContainer.insertAdjacentHTML('beforeend', '<span class="bundle-plus">+</span>');
    }
    
    let thumbnailHTML = '';
    
    if (productData.isCurrentProduct) {
      thumbnailHTML = `
        <img src="${productData.image}" alt="${productData.name}" class="bundle-thumbnail current-product" 
             onerror="this.src='${getBundleDefaultImage(productData.handle)}'" />
      `;
    } else {
      thumbnailHTML = `
        <a href="/products/${productData.handle}" class="bundle-thumbnail-link">
          <img src="${productData.image}" alt="${productData.name}" class="bundle-thumbnail related-product" 
               onerror="this.src='${getBundleDefaultImage(productData.handle)}'" />
        </a>
      `;
    }
    
    thumbnailsContainer.insertAdjacentHTML('beforeend', thumbnailHTML);
  });
}

// FUNCIÓN: ACTUALIZAR PRECIOS DEL BUNDLE
function updateBundlePrices() {
  const currentPriceElement = document.getElementById('bundleCurrentPrice');
  const originalPriceElement = document.getElementById('bundleOriginalPrice');
  
  if (!currentPriceElement || !originalPriceElement) {
    return;
  }
  
  let totalPrice = 0;
  let totalOriginalPrice = 0;
  let hasAnyDiscount = false;
  
  const checkedItems = document.querySelectorAll('.bundle-checkbox-item.checked');
  
  checkedItems.forEach((item) => {
    const productIndex = parseInt(item.getAttribute('data-product-index'));
    const product = globalBundleProductsData[productIndex];
    
    if (product && product.currentVariant) {
      const priceData = calculateProductPrice(product, product.currentVariant);
      totalPrice += priceData.finalPrice;
      totalOriginalPrice += priceData.originalPrice;
      
      if (priceData.hasDiscount) {
        hasAnyDiscount = true;
      }
    }
  });
  
  currentPriceElement.textContent = `${(totalPrice / 100).toFixed(2)}€`;
  
  if (hasAnyDiscount && totalOriginalPrice > totalPrice) {
    originalPriceElement.textContent = `${(totalOriginalPrice / 100).toFixed(2)}€`;
    originalPriceElement.style.display = 'inline';
  } else {
    originalPriceElement.style.display = 'none';
  }
}

// FUNCIÓN: ACTUALIZAR BOTÓN
function updateBundleButton() {
  const button = document.getElementById('bundleAddToCartBtn');
  if (!button) {
    return;
  }
  
  const checkedItems = document.querySelectorAll('.bundle-checkbox-item.checked');
  
  if (checkedItems.length > 0) {
    button.disabled = false;
    button.style.opacity = '1';
  } else {
    button.disabled = true;
    button.style.opacity = '0.5';
  }
}

// Añadir después de la función updateBundleButton()
function setupBundleButton() {
  const button = document.getElementById('bundleAddToCartBtn');
  if (button) {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (window.addBundleToCart) {
        window.addBundleToCart();
      } else {
        console.error('Función addBundleToCart no encontrada');
      }
    });
  }
}


// ========================================
// REPOSICIONAR ELEMENTOS DE LAYOUT
// ========================================

(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';
  const isDesktop = () => window.matchMedia(DESKTOP_QUERY).matches;

  function onceReady(checkFn, cb, tries = 60, gap = 120) {
    (function wait() {
      const ok = checkFn();
      if (ok) return cb(ok);
      if (tries <= 0) return;
      setTimeout(() => wait(--tries), gap);
    })();
  }

  function comesBefore(a, b) {
    if (!a || !b || a === b) return false;
    return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function fixDesktopOrder() {
    if (!isDesktop()) return;

    const priceInsertion = document.querySelector('.custom-price-insertion');
    const qtySelector    = document.getElementById('quantitySelector');
    const priceBar       = document.querySelector('.custom-price-container .price-container-main');

    if (!priceInsertion || !qtySelector || !priceBar) return;

    if (!comesBefore(qtySelector, priceBar)) {
      priceBar.parentNode.insertBefore(qtySelector, priceBar);
    }

    let qtyLabel = Array.from(document.querySelectorAll('.selector-personalizado'))
      .find(el => /seleccionar\s+cantidad/i.test((el.textContent || '').trim()));

    if (!qtyLabel) {
      qtyLabel = document.createElement('label');
      qtyLabel.className = 'selector-personalizado';
      qtyLabel.textContent = 'Seleccionar Cantidad';
      priceInsertion.parentNode.insertBefore(qtyLabel, priceInsertion);
    } else {
      const labelAfterBlock = !!(qtyLabel.compareDocumentPosition(priceInsertion) & Node.DOCUMENT_POSITION_PRECEDING);
      if (labelAfterBlock) {
        priceInsertion.parentNode.insertBefore(qtyLabel, priceInsertion);
      }
    }

    const sizeSelector = document.querySelector('.custom-size-selector');
    if (sizeSelector) {
      let variantLabel = null;
      const prev = sizeSelector.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('selector-personalizado') &&
          !/seleccionar\s+cantidad/i.test((prev.textContent || '').trim())) {
        variantLabel = prev;
      } else {
        variantLabel = Array.from(document.querySelectorAll('.selector-personalizado'))
          .find(el => el !== qtyLabel && !/seleccionar\s+cantidad/i.test((el.textContent || '').trim()));
      }

      if (variantLabel && !comesBefore(variantLabel, qtyLabel)) {
        qtyLabel.parentNode.insertBefore(variantLabel, qtyLabel);
      }
      if (!comesBefore(sizeSelector, qtyLabel)) {
        qtyLabel.parentNode.insertBefore(sizeSelector, qtyLabel);
      }
    }
  }

  function runFix() {
    onceReady(
      () =>
        document.querySelector('.custom-price-insertion') &&
        document.getElementById('quantitySelector') &&
        document.querySelector('.custom-price-container .price-container-main'),
      () => fixDesktopOrder()
    );
  }

  const BED_HANDLES = new Set(['cama-para-perros']);

  function getProductHandleFromPath() {
    const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function isBedProduct() {
    return BED_HANDLES.has(getProductHandleFromPath());
  }

  function fixBedDesktopOrder() {
    if (!isDesktop() || !isBedProduct()) return;

    const priceContainer = document.querySelector('.custom-price-container');
    const sizeSelector   = document.querySelector('.custom-size-selector');
    if (!priceContainer || !sizeSelector) return;

    let variantLabel = null;
    let sib = sizeSelector.previousElementSibling;
    while (sib && !(sib.classList && sib.classList.contains('selector-personalizado'))) {
      sib = sib.previousElementSibling;
    }
    if (sib && !/seleccionar\s+cantidad/i.test((sib.textContent || '').trim())) {
      variantLabel = sib;
    }

    const parent = priceContainer.parentNode;

    if (variantLabel && !comesBefore(variantLabel, priceContainer)) {
      parent.insertBefore(variantLabel, priceContainer);
    }
    if (!comesBefore(sizeSelector, priceContainer)) {
      parent.insertBefore(sizeSelector, priceContainer);
    }
  }

  function runFixBed() {
    if (!isBedProduct()) return;
    onceReady(
      () => document.querySelector('.custom-price-container') &&
            document.querySelector('.custom-size-selector'),
      () => fixBedDesktopOrder()
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    runFix();
    setTimeout(runFix, 800);
    runFixBed();
    setTimeout(runFixBed, 800);
  });

  window.addEventListener('resize', () => {
    if (isDesktop()) {
      setTimeout(runFix, 200);
      setTimeout(runFixBed, 200);
    }
  });

  document.addEventListener('variant:change', () => {
    if (isDesktop()) {
      setTimeout(runFix, 100);
      setTimeout(runFixBed, 100);
    }
  });
})();

// ========================================
// REPOSICIONAR SELLO DE GARANTÍA EN MÓVIL
// ========================================

function repositionGuaranteeBlock() {
  const guaranteeBlock = document.querySelector('.guarantee-block');
  const bundleContainer = document.querySelector('.bundle-products-container');
  if (!guaranteeBlock || !bundleContainer) return;

  function moveGuarantee() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      if (!guaranteeBlock.classList.contains('moved-to-mobile')) {
        bundleContainer.parentNode.insertBefore(guaranteeBlock, bundleContainer);
        guaranteeBlock.classList.add('moved-to-mobile');
      }
    } else {
      if (guaranteeBlock.classList.contains('moved-to-mobile')) {
        const mediaWrapper = document.querySelector('.product__media-wrapper');
        if (mediaWrapper) {
          mediaWrapper.appendChild(guaranteeBlock);
          guaranteeBlock.classList.remove('moved-to-mobile');
        }
      }
    }
  }

  moveGuarantee();
  window.addEventListener('resize', moveGuarantee);
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(repositionGuaranteeBlock, 100);
});